import * as types from './datepicker-header-constants'

export function setDates({ startDate, endDate }) {
  return { type: types.DATEPICKER_HEADER_SET_DATES, startDate, endDate }
}

export function setCompareDates({ compareStartDate }) {
  return { type: types.DATEPICKER_COMPARE_SET_DATE, compareStartDate }
}
